/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';

/**
 *
 * @export
 * @interface WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
 */
export interface WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto {
    /**
     *
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    description?: string | null;
    /**
     *
     * @type {number}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    amount?: number;
    /**
     *
     * @type {Array<number>}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    memberIds?: Array<number> | null;
    /**
     *
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    connectedYear?: string | null;
    /**
     *
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    generateAmountFromMembership?: boolean;
    /**
     *
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    printTemplate?: string | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto interface.
 */
export function instanceOfWebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDtoFromJSON(json: any): WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto {
    return WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'description': !exists(json, 'description') ? undefined : json['description'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'memberIds': !exists(json, 'memberIds') ? undefined : json['memberIds'],
        'connectedYear': !exists(json, 'connectedYear') ? undefined : json['connectedYear'],
        'generateAmountFromMembership': !exists(json, 'generateAmountFromMembership') ? undefined : json['generateAmountFromMembership'],
        'printTemplate': !exists(json, 'printTemplate') ? undefined : json['printTemplate'],
    };
}

export function WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDtoToJSON(value?: WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'description': value.description,
        'amount': value.amount,
        'memberIds': value.memberIds,
        'connectedYear': value.connectedYear,
        'generateAmountFromMembership': value.generateAmountFromMembership,
        'printTemplate': value.printTemplate,
    };
}
